export default __webpack_public_path__ + "static/media/students-gold.3e2e6f54.svg";